import {
  FETCH_SUBSCRIPTIONS_BEGIN,
  FETCH_SUBSCRIPTIONS_SUCCESS,
  FETCH_SUBSCRIPTIONS_FAILURE
} from '../actions/subscriptionActions';

const initialState = {
  items: [],
  availableProducts: [],
  loading: false,
  error: null
};

export default function subscriptionReducer(state = initialState, action) {
  switch(action.type) {
    case FETCH_SUBSCRIPTIONS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        items: action.payload.subscriptions,
        availableProducts: action.payload.availableProducts,
        totalItems: action.payload.totalItems,
      };

    case FETCH_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        items: []
      };

    default:
      return state;
  }
} 